module.exports = __webpack_public_path__ + "202408221624/img/icon_money_1.3e02531a.png";